import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';

export default class DataRetentionAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare state: StateService;

  get canRead(): boolean {
    if (!this.state.features?.canAccessDataRetention) return false;
    return this.authz.hasPermissionAtCurrentCompany(Permission.ACCOUNT_MANAGEMENT_DATA_RETENTION_POLICY_READ);
  }

  get canUpdate(): boolean {
    if (!this.state.features?.canAccessDataRetention) return false;
    return this.authz.hasPermissionAtCurrentCompany(Permission.ACCOUNT_MANAGEMENT_DATA_RETENTION_POLICY_MANAGE);
  }

  get canUpdateFieldSettings(): boolean {
    const subscription = this.state.visitorsSubscription;
    if (!subscription) return false;
    return this.canUpdate && !subscription.isStandardPlan && !subscription.isPremiumPlan;
  }
}
